<template>
  <div class="aaaaa" >
    <!-- 头部部分 -->
    <div class="bbbbb">
      <!-- <div ref="search_d">
        <el-row type="flex" class="row-bg">
          <el-col :span="3">
            <el-button type="primary" @click="newBtn">新建页面</el-button>
          </el-col>
        </el-row>
      </div> -->
      <!-- 头部部分 -->
      <div ref="search_d" class="dft-search">
        <el-form label-width="120px" label-height="60px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="页面名称" prop="pageName">
                <el-input v-model="queryInfo.condition.pageName" @keyup.enter.native="search" placeholder="请输入"
                  clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="页面状态" prop="status">
                <el-select clearable style="width: 100%;" v-model="queryInfo.condition.status" placeholder="页面状态">
                  <el-option label="全部状态" value=""></el-option>
                  <el-option label="已发布" value="1"></el-option>
                  <el-option label="未发布" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="display: flex; justify-content: flex-end">
              <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
              <el-button @click="reset" icon="el-icon-refresh-left">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 表格部分 -->
      <div>
        <el-button type="primary" @click="newBtn">新建页面</el-button>
        <el-table
          border
          ref="table"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :height="height"
          empty-text="暂无数据"
        >
          <!-- :reserve-selection="true"
          @selection-change="handleSelectionChange" -->
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            label="序号"
            type="index"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column label="页面名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.pageName }}</template>
          </el-table-column>
          <el-table-column label="状态" align="center" show-overflow-tooltip width="120">
            <template slot-scope="scope">
              {{ scope.row.status | showstatus}}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" show-overflow-tooltip width="170">
            <template slot-scope="scope">{{ scope.row.createTime }}</template>
          </el-table-column>
          <el-table-column label="访客量/浏览量" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ `${scope.row.visitorNum || ''}/${scope.row.viewNum || ''}` }}</template>
          </el-table-column>
          <el-table-column label="商品访客量/商品浏览量" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ `${scope.row.productViewNum || ''}/${scope.row.productVisitorNum || ''}` }}</template>
          </el-table-column>
          <el-table-column label="更新时间" align="center" show-overflow-tooltip width="170">
            <template slot-scope="scope">{{ scope.row.updateDt }}</template>
          </el-table-column>
          <el-table-column label="备注" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.remark }}</template>
          </el-table-column>
          <el-table-column label="操作" width="290" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row)" size="small"
              >编辑
              </el-button>
              <el-button type="text" @click="revise(scope.row)" size="small" style="color: #eb0"
              >修改
              </el-button>
              <el-button v-if="scope.row.isDefault!='1'"
                type="text"
                style="color: red"
                @click="handleDelte(scope.row)"
              >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.currPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      :title="labelType == 'add' ? '添加' : '编辑'"
      :visible.sync="showDialog"
      width="800px"
    >
      <el-form :model="tableForm.formData" ref="tableForm" size="small" label-position="left" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="页面名称" prop="pageName">
              <el-input v-model="tableForm.formData.pageName" @keyup.enter.native="search" placeholder="请输入"
                clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="页面状态" prop="status">
              <el-select clearable style="width: 100%;" v-model="tableForm.formData.status" placeholder="页面状态" :disabled="tableForm.formData.isDefault=='1'">
                <el-option label="已发布" value="1"></el-option>
                <el-option label="未发布" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="默认" prop="isDefault">
              <el-select clearable style="width: 100%;" v-model="tableForm.formData.isDefault" placeholder="是否默认">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="tableForm.formData.remark" placeholder="请输入"
                clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button size="small" @click="cancelForm('tableForm')"
        >取消</el-button
        >
        <el-button size="small" type="primary" @click="handleSave('tableForm')" :loading="btnloading"
        >确定</el-button
        >
      </span>
    </el-dialog>

  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  data () {
    return {
      labelType: 'add',
      // 添加分类类型 1-父类 2-子类
      addType: 1,
      // 如果添加分类类型是子类，保存父类编码和名称
      parentCode: '',
      parentName: '',
      showEditDialog: false,
      items: [],
      total: 0,
      queryInfo: {
        pageSize: 10,
        currPage: 1,
        condition: {
          merchantCode: JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.merchantCode
        }
      },
      tableForm: {
        formData: {
          pageName: '',
          status: '',
          isDefault:'',
        }
      },
      rules: {
        pageName: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur'
          }
        ],
        logo: [
          {
            required: true,
            message: '请上传封面图',
            trigger: 'change'
          }
        ]
      },
      showDialog: false,
      tableData: [],
      childList: [],
      height: window.innerHeight - 100, // 表格高度
      headerHeight: 0,
      ids: [],
      btnloading: false,
    }
  },
  filters: {
    showstatus(val){
      if(val == '1'){
        return '已发布'
      }else if(val == '0'){
        return '未发布'
      }else{
        return ''
      }
    }
  },

  created () {
    this.getList()
  },

  mounted () {
    this.$nextTick(() => {
      // 获取定义ref属性 和 元素高度
      this.headerHeight = this.$refs.search_d.offsetHeight
      window.addEventListener('resize', this.getHeight())
    })
  },

  methods: {
    // 修改分类上下架状态
    changePutOn (row) {
      const message = row.putOn === 1 ? '上架成功' : '已下架'
      this.$http
        .post('/productCategory/upDownStatus', {
          id: row.id,
          putOn: row.putOn
        })
        .then((response) => {
          if (response.data.code === 200) {
            this.$message({
              message: message,
              type: 'success'
            })
            this.getList()
          }
        })
        .catch((error) => {
          console.error('There was an error!', error)
        })
      console.log('3232', row)
    },
    // 监听表格高度
    getHeight () {
      this.height = window.innerHeight - this.headerHeight - 256
    },

    cancelItem () {
      this.showEditDialog = false
    },
    // 获取数据
    getList () {
      var that = this
      that.$http
        .post('/merchantRenovationPage/list', that.queryInfo)
        .then(function (response) {
          console.log(response.data.data)
          if (response.data.code == 200) {
            that.total = response.data.data.count
            that.queryInfo.currPage = response.data.data.currPage
            that.tableData = response.data.data.data
            // that.childList = response.data.data.data.childList
          }
        })
    },
    cancelForm () {
      this.showDialog = false
    },
    // 中文转 Unicode 序列（如 "你好" → "4F60597D"）
    chineseToUnicode(str) {
      return str.split('').map(char => 
        char.charCodeAt(0).toString(16).padStart(4, '0')
      ).join('').toUpperCase();
    },
    // 保存
    handleSave (formName) {
      var that = this
      
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.btnloading){return}
          this.btnloading = true
          // that.tableForm.formData.seq = Number(that.form.seq);

          const _data = {
            ...that.tableForm.formData,
            merchantCode: that.queryInfo.condition.merchantCode
          }
          if(this.labelType == 'add'){
            _data.createDt = dayjs().format('YYYY-MM-DD HH:mm:ss')
            _data.pageCode = `${this.chineseToUnicode(this.tableForm.formData.pageName)}_${new Date().getTime()}`
          }else{
            _data.updateDt = dayjs().format('YYYY-MM-DD HH:mm:ss')
          }
          const _url = this.labelType == 'add' ? '/merchantRenovationPage/save' : '/merchantRenovationPage/update'
          that.$http
            .post(_url, _data)
            .then(function (response) {
              if (response.data.code == 200) {
                that.$notify.success({
                  title: '提示',
                  message: '保存成功',
                  showClose: true
                })
                that.showDialog = false
                that.search()
              } else {
                that.$notify.info({
                  title: '提示',
                  message: response.data.message,
                  showClose: true
                })
              }
              that.btnloading = false
            })
            .catch(function (error) {
              that.btnloading = false
            })
        } else {
          // console.log("error submit!!");
          return false
        }
      })
    },

    // 编辑
    async edit (row) {
      if(row.pageCode == 'userMy'){
        this.$router.push({
          path: '/userMyManage',
        })
      }else{
        this.$router.push({
          path: '/storedecoration',
          query: {
            renovationCode: row.pageCode
          }
        })
      }
    },
    // 修改
    async revise (row) {
      this.labelType = "edit";
      this.tableForm.formData = JSON.parse(JSON.stringify(row))
      this.showDialog = true;
    },
    // 删除
    async handleDelte (row) {
      var that = this
      const confirmResult = await this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      if (confirmResult === 'confirm') {
        that.$http
          .post('/merchantRenovationPage/delete', { id: row.id })
          .then(function (res) {
            if (res.data.code == 200) {
              that.$notify.success({
                title: '提示',
                message: '删除成功',
                showClose: true
              })
              that.getList()
            } else {
              that.$notify.info({
                title: '提示',
                message: res.data.message,
                showClose: true
              })
            }
          })
      }
    },

    // 新增分类按钮
    newBtn () {
      this.labelType = 'add'
      this.addType = 1
      this.showDialog = true
      this.tableForm.formData = {
        pageName: '',
        status: '',
        isDefault: '',
      }
    },


    search(){
      this.queryInfo.currPage = 1
      this.getList()
    },
    reset(){
      this.queryInfo.condition = {
        merchantCode: JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.merchantCode
      }
      this.search()
    },
    // 修改页数大小
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
      this.getList()
    },

    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val
      this.getList()
    },
    // 全选
    handleSelectionChange (val) {
      var idList = []
      val.map((item) => {
        return idList.push(item.id)
      })
      this.ids = idList
      console.log(this.ids)
    },
    childHandChange (val) {
      this.ids = val.id
    },


  }
}
</script>
<style lang="less" scoped>
.aaaaa{
  min-height: 50%!important;
}
.bbbbb{
  min-height: 100%;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
}

.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
</style>
